var map = {
	"./冷机组/zpt.asm.jpg": "d3b3",
	"./发动机/5367673357085_stp.prt.jpg": "7c53",
	"./管子坡口机/zpt.asm.jpg": "cb5b",
	"./装卸车/71f00040001b001.asm.jpg": "0766"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f097";